import React from "react";

// A render failure in the brief must never take down the customer page around it.
export default class AccountBriefBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    // eslint-disable-next-line no-console
    console.error("[AccountBrief] render failed", error);
  }

  render() {
    if (this.state.failed) {
      return (
        <div className="cov-card">
          <p className="ab-empty">The account brief couldn't be shown. The rest of this page is unaffected.</p>
        </div>
      );
    }
    return this.props.children;
  }
}
